import { useMutation } from '@tanstack/react-query';
import {
  validationsApi,
  type ValidateBridgeRequest,
  type BridgeValidationResponse,
} from '@/lib/api';

interface UseValidateBridgeOptions {
  onSuccess?: (result: BridgeValidationResponse) => void;
  onError?: (error: Error) => void;
}

export function useValidateBridge(options?: UseValidateBridgeOptions) {
  return useMutation({
    mutationFn: (data: ValidateBridgeRequest) =>
      validationsApi.validateBridge(data),
    onSuccess: (result) => {
      options?.onSuccess?.(result);
    },
    onError: (error) => {
      console.error('Bridge validation failed:', error);
      options?.onError?.(error instanceof Error ? error : new Error(String(error)));
    },
  });
}
